import PropTypes from 'prop-types';
import { PriceContext } from '../contexts/PriceContext';
import { UserContext } from '../contexts/UserContext';
import { useRedirectToCheckout } from '../hooks/useRedirectToCheckout';
import { useTagManager } from '../hooks/useTagManager';
import { getUserLocale } from '../utils/general';
import PlanContainer from './Containers';
import FeatureTable from './FeatureTable';
import Wrapper from './Wrapper';

export default function AppContent({ data, getLabel, userDataActions }) {
	const { userData, onPlanSelect, onChangePlan, onPrevBtnClick, onNextBtnClick, updatePackages } = userDataActions;
	useTagManager({ userData, data });
	useRedirectToCheckout(data.general.purchase_package_version, data.consulting_packages, userData);

	const getContainers = () => {
		const defaultProps = {
			consultingPackages: data.consulting_packages,
			generalData: data.general,
			getLabel,
			onChangePlan,
			onNextBtnClick,
			onPlanSelect,
			onPrevBtnClick,
			updatePackages,
		};

		if (userData.step === 0) {
			const containers = Object.entries(data.plans).map(([key, plan]) => <PlanContainer {...defaultProps} id={key} key={key} plan={plan} />);
			return containers;
		} else {
			const [key, plan] = Object.entries(data.plans).find(([key]) => userData.plan === key);
			return <PlanContainer {...defaultProps} id={key} plan={plan} />;
		}
	};

	return (
		<Wrapper step={userData.step}>
			<PriceContext.Provider value={{ useDecimalPlaces: data.general.show_exact_prices }}>
				<UserContext.Provider value={{ userData, currency: data.general.currency, locale: getUserLocale() }}>{getContainers()}</UserContext.Provider>
			</PriceContext.Provider>
			<FeatureTable getLabel={getLabel} features={data.features} plans={data.plans} />
		</Wrapper>
	);
}

AppContent.propTypes = {
	data: PropTypes.object.isRequired,
	getLabel: PropTypes.func.isRequired,
	userDataActions: PropTypes.object.isRequired,
};
